<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-row class="justify-center">
      <v-col cols="12" md="8">
        <v-card class="mb-6">
          <v-card-title>Create a new PMS</v-card-title>
          <v-form @submit.prevent="submit" @reset="handleReset">
            <v-card-text>
              <v-text-field
                v-model="form.name.value.value"
                :error-messages="form.name.errorMessage.value"
                label="Name/Alias of the PMS"
              />
              <v-text-field
                v-model="form.abbrev.value.value"
                :error-messages="form.abbrev.errorMessage.value"
                label="Unique Abbreviation"
              />
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn type="reset">Reset</v-btn>
              <v-btn type="submit">Submit</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12" md="12">
        <v-card>
          <v-container>
            <v-row>
              <v-col cols="2" v-for="pms in pmses" :key="pms['id']">
                <v-card class="mb-4 text-center fill-height d-flex align-center" variant="tonal">
                  <v-card-text>
                    <b>id:</b> {{ pms['id'] }}<br/>
                    <b>name:</b> {{ pms['name'] }}<br/>
                    <b>abbrev:</b> {{ pms['abbrev'] }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { onMounted, ref } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createPMS, fetchPMSes } from "../remote/pms.js";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const pmses = ref([]);

// Validation Schema
const schema = yup.object({
  name: yup.string().max(30).required(),
  abbrev: yup.string().max(10).required(),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema,
  initialValues: {}
});

const form = getFormFromSchema(schema);

// noinspection JSValidateTypes
const submit = handleSubmit(async (values) => {
  let payload = {
    name: values['name'],
    abbrev: values['abbrev'],
  };
  console.log(payload);
  loadingOverlay.value = true;
  // Create PMS
  try {
    await createPMS(useAlerts, payload);
    pmses.value = await fetchPMSes();
  } catch (e) {
    useAlerts.value.errorAlert('Error during PMS creation', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

async function retrievePMSes() {
  loadingOverlay.value = true;
  try {
    pmses.value = await fetchPMSes();
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load PMSes', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
}

onMounted(retrievePMSes);

</script>

<style scoped>

</style>
